import EndYokeOpeningScreen from "@dana/Components/FindEndYoke/EndYokeOpeningScreen";
import EndYokeResultScreen from "@dana/Components/FindEndYoke/EndYokeResultScreen";
import KingPinOpeningScreen from "@dana/Components/FindKingPin/KingPinOpeningScreen";
import KingPinResultScreen from "@dana/Components/FindKingPin/KingPinResultScreen";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";
import { useEffect, useState } from "react";


const enum fields {
    assemblyDiagramImage = "assemblyDiagramImage",
    assemblyDiagramImageAltText = "assemblyDiagramImageAltText"

}

interface OwnProps extends PageProps {
    fields: {
        [fields.assemblyDiagramImage]: string;
        [fields.assemblyDiagramImageAltText]: string;
    };
}

export interface FindKingPinPageStyles {
    page?: MobiusPageProps;
}

export const findKingPinPageStyles: FindKingPinPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
}

const FindKingPinPage = ({ id, fields }: OwnProps) => {

    const styles = findKingPinPageStyles;

    const [make, setMake] = useState<string | null>(null);
    const [model, setModel] = useState<string | null>(null);
    const [queryStringCollected, setQueryStringCollected] = useState(false);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const queryParams = new URLSearchParams(window.location.search);
            setMake(queryParams.get("axleManufacturer"));
            setModel(queryParams.get("axelModel"));
            setQueryStringCollected(true);
        }
    }, []);

    return (
        <Page {...styles.page}>
            {queryStringCollected && (!make || !model) && (
                <KingPinOpeningScreen />
            )}

            {queryStringCollected && make && model && (
                <KingPinResultScreen
                    make={make}
                    model={model}
                    fields={fields}
                />
            )}
        </Page>
    )
};

const pageModule: PageModule = {
    component: FindKingPinPage,
    definition: {
        displayName: "Find King Pin Page",
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                fieldType: "Translatable",
                name: fields.assemblyDiagramImage,
                editorTemplate: "ImagePickerField",
                displayName: "Assembly Diagram Image",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.assemblyDiagramImageAltText,
                editorTemplate: "TextField",
                displayName: "Assembly Diagram Image Alt Text",
                defaultValue: "",
            },            
        ],
    },
};

export default pageModule;
